import React from 'react'

function FullScreenModalContainer(props: any) {

    return (
    <div id='fullscreen-modal-root' />
  )
}

export default FullScreenModalContainer